export default __webpack_public_path__ + "bc3fc94ba4e202b1fcb8eccd6b0c611a.png";